import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { Box, Paper, Typography } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';

export const RoleTypeDisclaimer = () => {
  const [memberDetails] = useGlobalState('memberDetails');

  const getRoleTypeDisclaimerText = () => {
    const roles = memberDetails?.prospectiveMemberRules?.memberRoles;
    const AS_role = roles?.find((role) => role.roleType === RoleType.ASSOCIATE);
    const canAddAssociateRoleType = AS_role?.maximumAllowed! > 0;

    if (canAddAssociateRoleType) {
      return 'An associate must live in the same household as the primary member or be a full-time student away at school/college.';
    } else {
      return 'Adult or dependent associates must live in the same household as the primary member or be a full-time student away at school/college.';
    }
  };

  const roleTypeDisclaimerText = getRoleTypeDisclaimerText();

  return (
    <Box id="role-type-disclaimer">
      <Paper
        sx={{
          padding: '0.75rem',
          background: '#F7F5F1',
          marginTop: '0.75rem',
          marginBottom: '1.5rem',
        }}
      >
        <Typography variant="b2Regular">
          <strong>Note:</strong> {roleTypeDisclaimerText}
        </Typography>
      </Paper>
    </Box>
  );
};
